import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
let { HEADER_BG_COLOR, HEADER_FONT_COLOR } = constants;

let styles = {
  base: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    height: 60,
    backgroundColor: HEADER_BG_COLOR,
    color: HEADER_FONT_COLOR,
    '@media (max-width: 768px)': {
      justifyContent: 'space-around'
    }
  },
  logo: {
    width: 120,
    flexShrink: 0,
    marginLeft: 30,
    marginRight: 'auto',
    '@media (max-width: 768px)': {
      display: 'none'
    }
  },
  logoImage: {
    width: 120,
    display: 'block'
  },
  field: {
    flexShrink: 0,
    width: 250,
    '@media (max-width: 475px)': {
      width: 100
    }
  },
  settings: {
    display: 'block',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: 0,
    width: 120,
    '@media (max-width: 475px)': {
      width: 80
    }
  },
  icon: {
    cursor: 'pointer'
  },
  iconLink: {
    textDecoration: 'none',
    paddingTop: 4,
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none'
    }
  },
  link: {
    textDecoration: 'none'
  },
  button: {
    display: 'flex'
  },
  back: {
    marginLeft: 10
  },
  navbarburger: {
    color: '#4a4a4a',
    cursor: 'pointer',
    display: 'block',
    height: '3.25rem',
    position: 'relative',
    width: '3.25rem',
    marginLeft: 'auto',
  },
  nvbspan: {
    backgroundColor: 'white',
    display: 'block',
    height: '1px',
    left: 'calc(50% - 8px)',
    position: 'absolute',
    transformOrigin: 'center',
    transitionDuration: '86ms',
    transitionProperty: 'background-color,opacity,transform',
    transitionTimingFunction: 'ease-out',
    width: '16px',
    ':nth-child(1)': {
      top: 'calc(50% - 6px)'
    },
    ':nth-child(2)': {
      top: 'calc(50% - 1px)'
    },
    ':nth-child(3)': {
      top: 'calc(50% + 4px)'
    }
  },
  navmenu:{
    display: 'flex',
    zIndex: 1000,
    flexFlow: 'column',
    position: 'absolute',
    backgroundColor: 'white',
    top: '55px',
    right: '15px',
    width: '120px',
    boxShadow: '0 8px 16px rgba(10, 10, 10, 0.1)'
  },
  navbarItem:{
    cursor: 'pointer',
    color: '#4a4a4a',
    display: 'block',
    lineHeight: '1.5',
    fontSize: '1rem',
    padding: '.5rem .75rem',
    position: 'relative',
    textDecoration: 'none',
    ':hover':{
      color: '#3273dc'
    }
  },
  navbarDivider:{
    backgroundColor: '#f5f5f5',
    border: 'none',
    height: '2px',
    margin: '.5rem 0'
  },
  isHidden:{
    visibility: 'hidden'
  },
  displayNone:{
    display: 'none'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/header/Header.styles.js